import ComparisonsRoute from './ComparisonsRoute';
import ComparisonRoute from './ComparisonRoute';
import { createComparison, deleteComparison, getComparison, patchComparison } from '@/api/comparisons';
import EditComparisonsModal from '@/components/comparisons/EditComparisonsModal';
import { redirect } from 'react-router';
import { comparisonActions } from '@/stores/comparisonStore';

const comparisonsRouter = {
  path: '/projects/:projectId/comparisons',
  id: 'comparisons',
  element: <ComparisonsRoute />,
  loader: () => {
    comparisonActions.clearPathways();
    return {};
  },
  handle: {
    title: _ => {
      return { title: `Compare` };
    },
  },
  children: [
    {
      path: '/projects/:projectId/comparisons/new',
      element: <EditComparisonsModal title="New Comparison" />,
      action: async ({ request, params }) => {
        const { projectId } = params;
        const form = await request.formData();
        const { name } = Object.fromEntries(form);

        try {
          const { data } = await createComparison(projectId, { name });
          return redirect(`/projects/${projectId}/comparisons/${data.id}`);
        } catch (error) {
          return redirect(`/projects/${projectId}/comparisons/new`);
        }
      },
    },
    {
      path: '/projects/:projectId/comparisons/:comparisonId',
      id: 'comparison',
      element: <ComparisonRoute />,
      errorElement: <ComparisonRoute />,
      handle: {
        crumb: comparison => ['Compare', comparison?.name],
        title: comparison => {
          return { title: `Compare: ${comparison?.name}` };
        },
      },
      loader: async ({ params: { projectId, comparisonId } }) => {
        const { data: comparison } = await getComparison(comparisonId);
        const comparisonData = comparisonActions.init(projectId, comparison);
        return { comparisonData, ...comparison };
      },
      children: [
        {
          path: '/projects/:projectId/comparisons/:comparisonId/edit',
          element: <EditComparisonsModal title="Edit Comparison" />,
          loader: async ({ params: { comparisonId } }) => {
            const { data: comparison } = await getComparison(comparisonId);
            return comparison;
          },
          action: async ({ request, params }) => {
            const { projectId, comparisonId } = params;
            const form = await request.formData();
            const { name } = Object.fromEntries(form);

            await patchComparison(comparisonId, { name });

            return redirect(`/projects/${projectId}/comparisons/${comparisonId}`);
          },
        },
        {
          path: '/projects/:projectId/comparisons/:comparisonId/destroy',
          action: async ({ params }) => {
            const { projectId, comparisonId } = params;
            await deleteComparison(comparisonId);
            return redirect(`/projects/${projectId}/comparisons`);
          },
        },
      ],
    },
  ],
};

export default comparisonsRouter;
